import { DatabaseService } from 'src/app/services/database.service';

export function getDataModel(id: string, dbService:DatabaseService) {  
    return dbService.texts.filter(x => x.id == id)[0].data;
}